export class EnableFromLimitExceededResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "updatedResource",
            "baseName": "updatedResource",
            "type": "InventoryResource",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EnableFromLimitExceededResponse.attributeTypeMap;
    }
    constructor() {
    }
}
